import { browser } from '$app/environment';
import { redirect } from '@sveltejs/kit';
import type { LayoutLoad } from './$types';
import Session from 'supertokens-web-js/recipe/session';
const authRoutes = ['/signin', '/signup'];
import { QueryClient } from '@tanstack/svelte-query';
import { client } from '$lib/api/Client';

export const load = (async ({ url, fetch }) => {
  if (
    browser &&
    (await Session.doesSessionExist()) &&
    authRoutes.includes(url.pathname)
  ) {
    throw redirect(302, '/');
  }

  client.setFetch(fetch);

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        enabled: browser, // Only fetch data on the client
      },
    },
  });

  return { queryClient };
}) satisfies LayoutLoad;
